import PDFPreview from "../../../assets/PDFPreview";
import { useStore } from "../../../store/store";

const PDFFiles = () => {
	const liveDetails = useStore((state) => state.live);
	return (
		<>
			{liveDetails?.files
				?.filter((file) => file.format.includes("pdf"))
				?.map((file) => {
					return (
						<a
							title={file.name}
							key={file.id}
							href={file.url}
							target="_blank"
							rel="noreferrer"
							download={file.name}
							className="advanced-settings-card"
						>
							<PDFPreview />
							<span className="w-full overflow-hidden text-ellipsis whitespace-nowrap">
								{file.name}
							</span>
						</a>
					);
				})}
		</>
	);
};

export default PDFFiles;
